import React from 'react';

import TextWithHint from '../TextWithHint';

import styles from './tagRenderer.scss';

const renderItem = tag => (
  <span key={tag} className={styles.tag}>
    <TextWithHint text={tag} />
  </span>
);

const tagRenderer = ({ cellData }) => {
  if (!cellData) {
    return <span className={styles.notAssigned}>Not Assigned</span>;
  }

  if (typeof cellData === 'string') {
    return renderItem(cellData);
  }

  return cellData.map(tag => renderItem(tag));
};

export default tagRenderer;
